import * as React from 'react';
import { ResultsProps } from '../../state-helpers/site-settings-props';
import { getResultsText } from '../../actions/results-count';

interface IProps {
    totalResults: number;
    pageResults: number;
    pageSize: number;
    currentPage: number;
    isLoading: boolean;
    resultsProps: ResultsProps;
    customClasses?: string;
    testID?: string;
}

interface IState {

}

export class ResultsCountMessage extends React.PureComponent<IProps, IState> {

    get resultsText() {
        const { totalResults, pageResults, pageSize, currentPage, isLoading, resultsProps } = this.props;

        return getResultsText(totalResults, pageResults, pageSize, currentPage, isLoading, resultsProps);
    }

    render() {
        const cssClasses = "paragraph-caption " + this.props.customClasses;
        return (
            <p className={cssClasses} data-testid={this.props.testID}>
                {this.resultsText}
            </p>
        );
    }
}